import React, { FC } from 'react';
import { getAdditionalLinks } from '../../selectors';
import { DEFAULT_SIDEBAR_LINKS, UTM_SOURCE_PARAM } from '../../utils/constants';
import LearnMoreItem from '../LearnMoreItem';
import copy from '../copy';

interface Props {
  app: any;
}

const AdditionalLinks: FC<Props> = ({ app }) => {
  const additionalLinks = getAdditionalLinks(app);

  const hasAdditionalLinks =
    additionalLinks?.length > 0 &&
    additionalLinks[0].name &&
    additionalLinks[0].url;

  const sidebarTitle = hasAdditionalLinks
    ? copy.additionalLinks.additionalLinksTitle
    : copy.additionalLinks.digitalOceanLinksTitle;

  return (
    <>
      <h4>{sidebarTitle}</h4>

      {hasAdditionalLinks ? (
        <>
          {additionalLinks.map(({ name, url, description }, index) => (
            <LearnMoreItem
              key={`${name} + ${index}`}
              url={
                url.indexOf('?') !== -1
                  ? `${url}&${UTM_SOURCE_PARAM}`
                  : `${url}?${UTM_SOURCE_PARAM}`
              }
              title={name}
              description={description}
            />
          ))}
        </>
      ) : (
        DEFAULT_SIDEBAR_LINKS.map(({ title, url, description }) => (
          <LearnMoreItem
            url={`${url}?${UTM_SOURCE_PARAM}`}
            title={title}
            description={description}
            key={title}
          />
        ))
      )}
    </>
  );
};

export default AdditionalLinks;
